// @ts-nocheck

if (!customElements.get('compatibility-checker')) {
  customElements.define(
    'compatibility-checker',
    class CompatibilityChecker extends HTMLElement {
      connectedCallback() {
        /** @type {HTMLElement | null} */
        this.modal = this.querySelector('[data-compatibility-modal]');
        /** @type {NodeListOf<HTMLButtonElement>} */
        this.openButtons = this.querySelectorAll('[data-compatibility-open]');
        /** @type {NodeListOf<HTMLButtonElement>} */
        this.closeButtons = this.modal
          ? this.modal.querySelectorAll('[data-compatibility-close]')
          : [];

        if (!(this.modal instanceof HTMLElement) || !this.openButtons.length) {
          return;
        }

        this.previouslyFocusedElement = null;

        this.onOpenClick = this.onOpenClick.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onOverlayClick = this.onOverlayClick.bind(this);

        this.openButtons.forEach((button) => {
          if (button instanceof HTMLButtonElement) {
            button.addEventListener('click', this.onOpenClick);
          }
        });

        this.closeButtons.forEach((button) => {
          if (button instanceof HTMLButtonElement) {
            button.addEventListener('click', this.onCloseClick);
          }
        });

        const overlay = this.modal.querySelector('[data-compatibility-overlay]');
        if (overlay instanceof HTMLElement) {
          overlay.addEventListener('click', this.onOverlayClick);
        }

        this.modal.hidden = true;
      }

      disconnectedCallback() {
        if (this.openButtons) {
          this.openButtons.forEach((button) => {
            if (button instanceof HTMLButtonElement) {
              button.removeEventListener('click', this.onOpenClick);
            }
          });
        }

        if (this.closeButtons) {
          this.closeButtons.forEach((button) => {
            if (button instanceof HTMLButtonElement) {
              button.removeEventListener('click', this.onCloseClick);
            }
          });
        }

        if (this.modal instanceof HTMLElement) {
          const overlay = this.modal.querySelector('[data-compatibility-overlay]');
          if (overlay instanceof HTMLElement) {
            overlay.removeEventListener('click', this.onOverlayClick);
          }
        }

        document.removeEventListener('keydown', this.onKeyDown);
        document.body.classList.remove('compatibility-checker--modal-open');
      }

      onOpenClick(event) {
        event.preventDefault();
        this.openModal(event.currentTarget);
      }

      onCloseClick(event) {
        event.preventDefault();
        this.closeModal();
      }

      onOverlayClick(event) {
        event.preventDefault();
        this.closeModal();
      }

      onKeyDown(event) {
        if (!(event instanceof KeyboardEvent)) return;

        if (event.key === 'Escape') {
          this.closeModal();
          return;
        }

        if (event.key !== 'Tab') return;
        if (!(this.modal instanceof HTMLElement) || this.modal.hidden) return;

        const focusableSelectors = [
          'a[href]',
          'button:not([disabled])',
          'input:not([disabled])',
          'select:not([disabled])',
          'textarea:not([disabled])',
          '[tabindex]:not([tabindex="-1"])'
        ];

        const focusableElements = Array.from(
          this.modal.querySelectorAll(focusableSelectors.join(','))
        ).filter((el) => el instanceof HTMLElement);

        if (!focusableElements.length) {
          return;
        }

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        const activeElement = document.activeElement;

        if (!event.shiftKey && activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        } else if (event.shiftKey && activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        }
      }

      openModal(trigger) {
        if (!(this.modal instanceof HTMLElement)) return;

        this.previouslyFocusedElement =
          trigger instanceof HTMLElement ? trigger : document.activeElement;

        this.modal.hidden = false;
        document.body.classList.add('compatibility-checker--modal-open');
        document.addEventListener('keydown', this.onKeyDown);

        const dialog = this.modal.querySelector('[role="dialog"]');
        if (dialog instanceof HTMLElement) {
          dialog.setAttribute('aria-hidden', 'false');
        }

        const focusTarget =
          this.modal.querySelector('[data-compatibility-initial-focus]') ||
          this.modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

        if (focusTarget instanceof HTMLElement) {
          focusTarget.focus();
        }
      }

      closeModal() {
        if (!(this.modal instanceof HTMLElement)) return;

        this.modal.hidden = true;
        document.body.classList.remove('compatibility-checker--modal-open');
        document.removeEventListener('keydown', this.onKeyDown);

        const dialog = this.modal.querySelector('[role="dialog"]');
        if (dialog instanceof HTMLElement) {
          dialog.setAttribute('aria-hidden', 'true');
        }

        if (this.previouslyFocusedElement instanceof HTMLElement) {
          this.previouslyFocusedElement.focus();
        }
      }
    }
  );
}

